import { render, staticRenderFns } from "./schemaAquiringLimit.vue?vue&type=template&id=72c9be6e"
import script from "./schemaAquiringLimit.vue?vue&type=script&lang=js"
export * from "./schemaAquiringLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports